import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';


const SecondaryActions = ({ plannerData, onCreateSimilar }) => {
  const navigate = useNavigate();

  const actionItems = [
    {
      title: 'Create New Planner',
      description: 'Start fresh with a completely new design',
      icon: 'Plus',
      color: 'primary',
      action: () => navigate('/planner-setup-wizard')
    },
    {
      title: 'Create Similar Planner',
      description: 'Use the same settings with minor modifications',
      icon: 'Copy',
      color: 'secondary',
      action: onCreateSimilar
    },
    {
      title: 'View Dashboard',
      description: 'Manage all your planners in one place',
      icon: 'LayoutDashboard',
      color: 'accent',
      action: () => navigate('/user-account-dashboard')
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-muted rounded-lg flex items-center justify-center">
          <Icon name="Zap" size={20} className="text-muted-foreground" />
        </div>
        <div>
          <h2 className="font-heading text-lg font-semibold text-foreground">
            What's Next?
          </h2>
          <p className="font-body text-sm text-muted-foreground">
            Continue your planner journey
          </p>
        </div>
      </div>
      <div className="space-y-4">
        {actionItems?.map((item, index) => (
          <button
            key={index}
            onClick={item?.action}
            className="w-full p-4 rounded-lg border border-border hover:border-primary/20 hover:bg-muted/50 transition-all duration-200 text-left group"
          >
            <div className="flex items-center space-x-4">
              <div className={`
                w-12 h-12 rounded-lg flex items-center justify-center group-hover:scale-105 transition-transform duration-200
                ${item?.color === 'primary' ? 'bg-primary/10 text-primary' : ''}
                ${item?.color === 'secondary' ? 'bg-secondary/10 text-secondary' : ''}
                ${item?.color === 'accent' ? 'bg-accent/10 text-accent' : ''}
              `}>
                <Icon name={item?.icon} size={20} />
              </div>
              
              <div className="flex-1">
                <h3 className="font-body font-semibold text-foreground group-hover:text-primary transition-colors">
                  {item?.title}
                </h3>
                <p className="font-body text-sm text-muted-foreground">
                  {item?.description}
                </p>
              </div>
              
              <Icon 
                name="ArrowRight" 
                size={16} 
                className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all duration-200" 
              />
            </div>
          </button>
        ))}
      </div>
      {/* Quick Stats */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="grid grid-cols-2 gap-4 text-center">
          <div>
            <div className="font-heading text-xl font-bold text-primary">
              {plannerData?.pageCount}
            </div>
            <div className="font-caption text-xs text-muted-foreground">
              Pages Created
            </div>
          </div>
          <div>
            <div className="font-heading text-xl font-bold text-success">
              100%
            </div>
            <div className="font-caption text-xs text-muted-foreground">
              Customized
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondaryActions;